import axios from "axios"

import {prepareFormData} from 'help@/store'

// actions
export const actions = {

    async fillData ({state, commit}, itemId) {
        const response = await axios.get(state.resourceUrl + 'fill/' + itemId)
        commit('fillEditFormData', response['data'])
    },

    // if formType == create
    async getGroupsByType ({commit, state}, typeId) {
        const response = await axios.get(state.resourceUrl + 'fieldsForType/' + typeId)
        commit('fillGroupsForMachineryType', response['data'])
        commit('fillOrigins')
    },

    // if formType == edit
    async getGroupsByItem ({commit, state}, itemId) {
        const response = await axios.get(state.resourceUrl + 'fieldsForItem/' + itemId)
        commit('fillGroupsForMachineryType', response['data'])
        commit('fillOrigins')
    },

    async createItem ({state, getters}, payload) {
        await axios.post(state.resourceUrl, {
            type: payload,
            ...prepareFormData(state),
        })
    },

    async updateItem ({state}, payload) {
        return await axios.put(state.resourceUrl + payload.itemId, {
            type: payload.typeId,
            ...prepareFormData(state),
        })
    },

    async getDependentOptions ({commit, state}, {url, id, valueParent}) {
        const fullUrl =
            url + id + '/' + valueParent

        axios.get(fullUrl).then((response) => {
            commit('updateExtra', {
                id,
                extra: response['data'],
            });
        })
    },

}

export default actions
